import React, { useEffect, useState } from 'react';
import { Megaphone, X, ChevronDown, ChevronUp } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const LS_KEY = 'portal_banner_dismissed_rev';

// Erste Zeile wird zur Überschrift, wenn der Text mehrzeilig ist und die Zeile kurz genug ist
const splitBanner = (text) => {
  const lines = (text || '').trim().split('\n');
  const first = (lines[0] || '').trim();
  if (lines.length > 1 && first.length <= 90) return { title: first, body: lines.slice(1).join('\n').trim() };
  return { title: '', body: (text || '').trim() };
};

// Reine Darstellung – wird im Kundenportal und als Vorschau im Admin verwendet
export const PortalBannerView = ({ text, ausblendbar = true, onDismiss, preview = false }) => {
  const [open, setOpen] = useState(false);
  const { title, body } = splitBanner(text);
  if (!title && !body) return null;
  const long = body.length > 240 || body.split('\n').length > 3;
  return (
    <div className="border-b border-brand-gold/40 bg-brand-gold/15 text-brand-navy" data-testid={preview ? 'portal-banner-preview' : 'portal-banner'}>
      <div className={`${preview ? '' : 'max-w-5xl mx-auto'} px-4 lg:px-6 py-3 flex items-start gap-3`}>
        <div className="w-9 h-9 rounded-xl bg-brand-gold/30 text-brand-navy flex items-center justify-center flex-shrink-0"><Megaphone className="w-5 h-5" /></div>
        <div className="flex-1 min-w-0">
          {title && <p className="text-sm font-semibold leading-snug" data-testid="portal-banner-title">{title}</p>}
          {body && (
            <p className={`text-sm leading-relaxed whitespace-pre-line break-words ${title ? 'mt-1' : ''} ${long && !open ? 'line-clamp-2' : ''}`} data-testid="portal-banner-text">
              {long && !open ? body.replace(/\s*\n\s*/g, ' ') : body}
            </p>
          )}
          {long && (
            <button type="button" onClick={() => setOpen(o => !o)} data-testid="portal-banner-toggle"
              className="mt-1 inline-flex items-center gap-1 text-xs font-semibold text-brand-navy/80 hover:text-brand-navy">
              {open ? <><ChevronUp className="w-3.5 h-3.5" /> Weniger anzeigen</> : <><ChevronDown className="w-3.5 h-3.5" /> Mehr lesen</>}
            </button>
          )}
        </div>
        {ausblendbar && (
          <button type="button" onClick={onDismiss} aria-label="Hinweis ausblenden" data-testid="portal-banner-dismiss"
            className="w-8 h-8 rounded-lg flex items-center justify-center text-brand-navy/60 hover:text-brand-navy hover:bg-brand-gold/25 flex-shrink-0">
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
};

// Portalweiter Banner (Admin → System → Wartung): oben auf jeder Kundenseite, gefiltert nach Zugangsart
export const PortalBanner = () => {
  const [banner, setBanner] = useState(null);
  useEffect(() => {
    let alive = true;
    fetch(`${API}/api/maintenance/banner`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then(r => (r.ok ? r.json() : null))
      .then(d => { if (alive && d?.enabled) setBanner(d); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  if (!banner) return null;
  if (banner.ausblendbar && localStorage.getItem(LS_KEY) === banner.rev) return null;
  const dismiss = () => { localStorage.setItem(LS_KEY, banner.rev); setBanner(null); };
  return <PortalBannerView text={banner.text} ausblendbar={banner.ausblendbar} onDismiss={dismiss} />;
};

export default PortalBanner;
